import styled from "styled-components";

export const DocumentPreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
`;

export const VideoIconOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const AttachmentDivider = styled.div`
  width: 1.5px;
  height: 10px;
  background: #d9d9d9;
  margin: 1px 16px;
`;

export const sourceHandleStyle: React.CSSProperties = {
  background: "#616161",
  width: "12px",
  height: "12px",
  right: "-6px",
  zIndex: 100,
  boxShadow: "0px 0px 0px 5px #E0E0E0",
  border: "none",
};
